import BulletinBoardDetail from "pages/BulletinBoard/BulletinBoardDetail";
import BulletinBoardPersonal from "pages/BulletinBoard/BulletinBoardPersonal";
import BulletinBoard from "pages/BulletinBoard/BulletinBoard";
import MessageBox from "pages/MessageBox/MessageBox";
import MyNotifications from "pages/MyNotifications/MyNotifications";
import MyProfile from "pages/Profile/MyProfile";
import MyFavorites from "pages/MyFavorites/MyFavorites";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Header from "layout/Header/Header/Header";
import Footer from "layout/Footer/Footer/Footer";
import Navbar from "layout/Navbar/Navbar";
import DefaultPage from "pages/Page/Page";
import PageNotFound from "pages/PageNotFound/PageNotFound";
import Home from "pages/Homepage/Home";
import { useAccount } from "context/AccountContext";
import DialogContextProvider from "context/DialogContext";
import ProfileSearch from "pages/Profile/ProfileSearch";
import Login from "features/authentication/components/Login";
import Logout from "features/authentication/components/Logout";
import Profile from "pages/Profile/Profile";
import Dashboard from "pages/Dashboard/Dashboard";
import Maintenance from "pages/Maintenance/Maintenance";
import PageUnsubscribe from "pages/Profile/PageUnsubscribe";
import ErrorBoundary from "features/errors/utils/ErrorBoundary";
import Group from "pages/Groups/Group";
import Groups from "pages/Groups/Groups";
import GroupsPersonal from "pages/Groups/GroupsPersonal";
import Marketplace from "pages/Marketplace/Marketplace";
import MonthlyHighlights from "pages/MonthlyHighlights/MonthlyHighlights";
import HeroPhotoOfTheMonth from "features/monthlyhighlights/assets/images/hero-photo.svg?v2";
import HeroThemeOfTheMonth from "features/monthlyhighlights/assets/images/hero-theme.svg?v2";
import HeroTheBigQuestion from "features/monthlyhighlights/assets/images/hero-big-question.svg";
import GameOverview from "pages/Games/GameOverview";
import GameDetail from "pages/Games/GameDetail";
import ActiviteitenHero from "pages/Activities/assets/hero-activiteiten.png"
import Cookies from "pages/Cookies/Cookies";

function ContentRouter() {
  const { user } = useAccount();

  const routes = [
    {
      bundle: 'frontpage',
      path: '/',
      component: <Home title="Welkom"/>,
      needsAuthentication: false,
    },
    {
      title: 'Startpagina',
      path: '/startpagina',
      component: <Dashboard/>,
    },
    {
      title: 'Berichtenbox',
      path: '/berichtenbox',
      component: <MessageBox/>,
    },
    {
      path: '/leden',
      component: <ProfileSearch title="Leden zoeken"/>,
    },
    {
      path: '/leden/favorieten',
      bundle: 'profile',
      component: <MyFavorites/>
    },
    {
      path: '/leden/*',
      bundle: 'profile',
      component: <Profile/>
    },
    {
      path: '/vraag-en-aanbod',
      bundle: 'node',
      component: <Marketplace
        title={ `Vraag en aanbod` }
      />,
    },
    {
      path: '/vraag-en-aanbod/*',
      bundle: 'bulletin',
      component: <BulletinBoardDetail/>,
    },
    {
      path: '/doe-mee/thema-van-de-maand',
      bundle: 'node',
      component: <MonthlyHighlights
        title={ `Thema van de maand` }
        path={ `/doe-mee/thema-van-de-maand` }
        hero={ HeroThemeOfTheMonth }
      />,
    },
    {
      path: '/doe-mee/de-grote-vraag',
      bundle: 'node',
      component: <MonthlyHighlights
        title={ `De grote vraag` }
        path={ `/doe-mee/de-grote-vraag` }
        hero={ HeroTheBigQuestion }
      />,
    },
    {
      path: '/doe-mee/spelletjes',
      bundle: 'node',
      component: <GameOverview
        title={ `Puzzels` }
        path={ `/doe-mee/spelletjes` }
      />,
    },
    {
      path: '/doe-mee/spelletjes/kruiswoord',
      bundle: 'node',
      component: <GameDetail
        title={ `Kruiswoord` }
        gameId={ `crossword` }
      />,
    },
    {
      path: '/doe-mee/spelletjes/woordkraker',
      bundle: 'node',
      component: <GameDetail
        title={ `Woordkraker` }
        gameId={ `wordguess` }
      />,
    },
    {
      path: '/doe-mee/spelletjes/woordzoeker',
      bundle: 'node',
      component: <GameDetail
        title={ `Woordzoeker` }
        gameId={ `wordsearch` }
      />,
    },
    {
      path: '/doe-mee/spelletjes/sudoku',
      bundle: 'node',
      component: <GameDetail
        title={ `Sudoku` }
        gameId={ `sudoku` }
      />,
    },
    {
      path: '/doe-mee/foto-van-de-maand',
      bundle: 'node',
      component: <MonthlyHighlights
        title={ `Foto van de maand` }
        path={ `/doe-mee/foto-van-de-maand` }
        hero={ HeroPhotoOfTheMonth }
      />,
    },
    {
      path: '/doe-mee/*/*',
      bundle: 'node',
      component: <BulletinBoardDetail/>,
    },
    {
      path: '/groepen/mijn-groepen',
      component: <GroupsPersonal/>,
    },
    {
      path: '/groepen',
      bundle: 'node',
      component: <Groups title="Groepen"/>
    },
    {
      path: '/groepen/*/groepsberichten/*',
      bundle: 'bulletin',
      component: <BulletinBoardDetail/>
    },
    {
      path: '/groepen/*',
      bundle: 'group',
      component: <Group/>
    },
    {
      path: '/prikbord/mijn-prikbord',
      component: <BulletinBoardPersonal/>,
    },
    {
      path: '/prikbord',
      component: <BulletinBoard title="Ledenprikbord"/>,
    },
    {
      path: '/prikbord/*',
      bundle: 'bulletin',
      component: <BulletinBoardDetail/>,
    },
    {
      title: 'Activiteiten',
      path: '/activiteiten',
      contentGridType: 'small',
      contentPadding: true,
      contentBackground: true,
      needsAuthentication: false,
      topBanner: true,
      topBannerImage: ActiviteitenHero,

    },
    {
      title: 'Help',
      path: '/help',
      contentGridType: 'small',
      contentPadding: true,
      contentBackground: true,
      containerPadding: true,
      needsAuthentication: false,
    },
    {
      title: 'Inloggen',
      path: '/login',
      needsAuthentication: false,
      component: <Login/>
    },
    {
      title: 'Mijn profiel',
      path: '/mijn-profiel',
      component: <MyProfile/>,
    },
    {
      title: 'Mijn meldingen',
      path: '/mijn-meldingen',
      component: <MyNotifications/>,
    },
    {
      title: 'Handleiding',
      path: '/handleiding',
      contentGridType: 'small',
      contentPadding: true,
      contentBackground: true,
      containerPadding: true,
      needsAuthentication: false,
    },
    {
      title: 'Huisregels',
      path: '/huisregels',
      contentGridType: 'small',
      contentPadding: true,
      contentBackground: true,
      containerPadding: true,
      needsAuthentication: false,
    },
    {
      title: 'Contact',
      path: '/contact',
      contentGridType: 'small',
      contentPadding: true,
      contentBackground: true,
      containerPadding: true,
      needsAuthentication: false,
    },
    {
      title: 'Privacyverklaring',
      path: '/privacyverklaring',
      contentGridType: 'small',
      contentPadding: true,
      contentBackground: true,
      containerPadding: true,
      needsAuthentication: false,
    },
    {
      title: 'Disclaimer',
      path: '/disclaimer',
      contentGridType: 'small',
      contentPadding: true,
      contentBackground: true,
      containerPadding: true,
      needsAuthentication: false,
    },
    {
      title: 'Cookies',
      path: '/cookies',
      component: <Cookies/>,
      needsAuthentication: false,
    },
    {
      title: 'Afmelden notificaties',
      path: '/mijn-meldingen/afmelden',
      component: <PageUnsubscribe/>,
      needsAuthentication: false,
    },
    {
      title: 'Uitloggen...',
      path: '/logout',
      needsAuthentication: false,
      component: <Logout/>
    },
    {
      title: 'Onderhoud',
      path: '/onderhoud',
      needsAuthentication: false,
      component: <Maintenance/>
    },
  ];

  return (
    <Router>
      <DialogContextProvider>
        <div className="page-container">
          <div className="container-grow">
            <Header/>

            <Switch>
              {
                routes.map((route, index) => {
                    let content;
                    if (route.needsAuthentication !== false && !user) {
                      content = <Login/>
                    } else if (route.path === `/` && user) {
                      content = <Redirect to="/startpagina"/>;
                    } else if (route.component) {
                      content = route.component;
                    } else {
                      content =
                        <DefaultPage title={ route.title && route.title }
                                     bundle={ route.bundle ? route.bundle : 'page' }
                                     contentGridType={ route.contentGridType }
                                     contentPadding={ route.contentPadding }
                                     contentBackground={ route.contentBackground }
                                     containerPadding={ route.containerPadding }
                                     topBanner={ route.topBanner }
                                     topBannerImage={ route.topBannerImage }
                        />
                    }
                    return (
                      <Route key={ index } path={ route.path } exact>
                        <ErrorBoundary level={ `page` }>
                          { content }
                        </ErrorBoundary>
                      </Route>
                    )
                  }
                )
              }
              <Route>
                <PageNotFound/>
              </Route>
            </Switch>
          </div>
          <Footer/>
          <Navbar/>
        </div>
      </DialogContextProvider>
    </Router>
  )
}

export default ContentRouter;
